import css from 'styled-jsx/css';

const styles = css.global`#santander-carousel {
  background: #C00;
  padding: 24px 0;
  height: 615px;
}

#santander-carousel .santander-carousel-contain {
  width: 100%;
  position: relative;
}

#santander-carousel .santander-carousel-contain .slide a {
  display: flex;
  width: calc(100% - 1px);
}

#santander-carousel .bg-banner {
  width: 100%;
  height: 510px;
}

#santander-carousel .bg-banner img {
  width: 100%;
  object-fit: cover;
  height: 510px;
  border-radius: 4px;
  object-position: -10px;
}

#santander-carousel .conteudo-banner {
  position: absolute;
  top: 0;padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
  height: 510px;
}

#santander-carousel .conteudo-banner .banner-title {
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
  margin: 0;
  max-width: 600px;
}

#santander-carousel .conteudo-banner .banner-subtitle {
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
}

#santander-carousel .conteudo-banner .banner-subtitle b {
  font-weight: 600;
}

#santander-carousel .conteudo-banner .banner-saber-mais {
  background-color: #c00;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 80px;
  height: 50px;
  width: 200px;
  text-decoration: none;
  font-family: "SantanderText";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 100px;
}

#santander-carousel .conteudo-banner .banner-saber-mais-sem-parar {
  margin-bottom: 50px;
}

#santander-carousel .home-pagination {
  margin-top: 27px;
}

#santander-carousel .pagination-container .bullet.active,
#santander-carousel .pagination-container .bullet[selected] {
  background-color: #000;
}

#santander-carousel .pagination-container .bullet {
  background-color: #999999;
}

#santander-carousel .home-pagination .embla__prev {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_left_white.svg);
  background-size: 24px 24px;
}

#santander-carousel .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_right_white.svg);
  background-size: 24px 24px;
}

@media (min-width: 460px) {
  #santander-carousel .bg-banner img {
    object-position: -15px;
  }
}

@media (min-width: 601px) {
  #santander-carousel .bg-banner img {
    object-position: -95px;
  }

  #santander-carousel .conteudo-banner .banner-saber-mais {
    width: 240px;
    margin: 0;
  }

  #santander-carousel .conteudo-banner .banner-saber-mais-sem-parar {
    margin-bottom: 0;
  }
}

@media (min-width: 801px) {
  #santander-carousel .bg-banner img {
    object-position: -135px;
  }
}

@media (min-width: 992px) {
  #santander-carousel .conteudo-banner {
    padding: 32px 16px;
  }
  #santander-carousel {
    padding: 48px 0;
    height: 657px;
  }

  #santander-carousel .bg-banner {
    height: 510px;
  }

  #santander-carousel .bg-banner img {
    height: 510px;
  }

  #santander-carousel .conteudo-banner {
    height: 510px;
  }
}

@media (min-width: 1236px) {
  #santander-carousel .bg-banner img {
    object-position: center;
  }
  #santander-carousel .conteudo-banner {
    padding: 32px 117px;
  }
}`;

export default styles;